/*
 * Ryan O'Dowd
 * 2025-12-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import utilities from '@utils/utilities';

function prepareUpsertStatement(collection, existingRecord, rowData) {
  if (existingRecord) {
    return existingRecord.prepareUpdate((row) => {
      for (const [key, value] of Object.entries(rowData)) {
        row[utilities.snakeToCamel(key)] = value;
      }
    });
  } else {
    return collection.prepareCreate((row) => {
      for (const [key, value] of Object.entries(rowData)) {
        row[utilities.snakeToCamel(key)] = value;
      }
    });
  }
}

export default {
  prepareUpsertStatement,
};
